import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=65398b35&"
import script from "./Background.vue?vue&type=script&lang=ts&"
export * from "./Background.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65398b35')) {
      api.createRecord('65398b35', component.options)
    } else {
      api.reload('65398b35', component.options)
    }
    module.hot.accept("./Background.vue?vue&type=template&id=65398b35&", function () {
      api.rerender('65398b35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/Background.vue"
export default component.exports